import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import ChangelogIndex from '@/pages/Changelog/ChangelogIndex'

const crumbs = [{ to: '/changelog', name: 'Changelog' }]

export default function ChangelogContainer(props) {
  return <>
    <Breadcrumbs>
      {crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className='text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100'>
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle="What's new">
      {[]}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/changelog']}>
        <ChangelogIndex />
      </Route>
    </Switch>
  </>
}
